<template>
  <div class="footer-info-wrap">
    <div class="footer-content">©深圳市新材料行业协会 版权所有 &nbsp; <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备13056780号</a> </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBeianPortal:false
    }
  },
  mounted() {
    let key = process.env.VUE_APP_KEY
    const showBeianPortalKeys = ['Hy']
    this.showBeianPortal = showBeianPortalKeys.includes(key)
  }
}
</script>
